import React, { useCallback, useEffect, useState } from 'react'
import Link from 'next/link'

import BagIcon from '@/assets/svg/HeroBagIcon'
import HeroClockIcon from '@/assets/svg/HeroClockIcon'
import HeroRecycleIcon from '@/assets/svg/HeroRecycleIcon'
import MenuBarIcon from '@/assets/svg/MenuBarIcon'
import XBarIcon from '@/assets/svg/XBarIcon'
import useKva, { LANDING_PAGE_LENDING } from '@/hooks/useKVA'

import Logo from '../../Logo'

export default function Header({ loanApplyUrl }) {
  const { addEventAction } = useKva()
  const [activeSection, setActiveSection] = useState('')

  const handleScrollNavbar = useCallback(() => {
    const { scrollY } = window
    const navbar = document.getElementById('navbar')
    if (!navbar) return
    const isBackgroundWhite = navbar.classList.contains('!bg-white')
    if (scrollY !== 0 && !isBackgroundWhite) {
      navbar.classList.add('!bg-white')
      navbar.classList.add('!shadow-white-navbar-shadow')
    } else if (scrollY === 0 && isBackgroundWhite) {
      navbar.classList.remove('!bg-white')
      navbar.classList.remove('!shadow-white-navbar-shadow')
    } else {
      //
    }
  }, [])

  const handleScroll = useCallback(() => {
    handleScrollNavbar()

    // Check which section is in viewport
    const sections = [
      'loi-ich',
      'quy-trinh-vay',
      'doi-tac',
      'cau-hoi-thuong-gap'
    ]
    const headerHeight = document.getElementById('navbar')?.offsetHeight || 0
    
    for (const sectionId of sections) {
      const section = document.getElementById(sectionId)
      if (section) {
        const rect = section.getBoundingClientRect()
        // Add a buffer equal to header height + 50px to consider a section "active" earlier
        if (rect.top <= headerHeight + 50 && rect.bottom >= headerHeight) {
          setActiveSection(sectionId)
          break
        }
      }
    }
  }, [handleScrollNavbar])

  function onToggleMenu() {
    const navLinks = document.querySelector('.offcanvas-body')
    const closeButton = document.querySelector('.navbar-close-button')
    closeButton.classList.toggle('hidden')
    navLinks.classList.toggle('!top-0')
  }
  const onClickHeroBannerRegisterButton = () => {
    addEventAction(LANDING_PAGE_LENDING, 'click_button_hero_banner')
  }
  const onClickNavbarRegisterButton = () => {
    addEventAction(LANDING_PAGE_LENDING, 'click_button_header')
  }

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', handleScroll)
      return () => window.removeEventListener('scroll', handleScroll)
    }
  }, [handleScroll])

  return (
    <div
      className="
      flex justify-center
      3xl:h-[935px] 2xl:h-[800px] xl:h-[625px]  lg:h-[580px] md:h-[351px]  h-[667px]
      bg-cover relative md:bg-hero-background bg-hero-background-background
      "
    >
      <div className="max-w-[1920px] 3xl:w-[1920px] 2xl:w-[1600px] xl:w-[1366px] lg:w-[1280px] md:w-[768px] w-[375px] ">
        <div
          id="navbar"
          className="fixed left-0 w-full flex justify-center z-[99999999]"
        >
          <div
            className="
          flex items-center justify-between z-[999]
          px-4 md:px-8 lg:px-12 xl:px-[83px] 2xl:px-[120px]
          pb-4 pt-5  3xl:w-[1920px] 2xl:w-[1600px] xl:w-[1366px] lg:w-[1280px] md:w-[768px] w-[375px]
        "
          >
            <nav
              className="w-full  max-w-[1680px] "
              aria-label="Offcanvas navbar large"
            >
              <div className="p-0 flex flex-row justify-between items-center">
                <div className="flex items-center justify-center">
                  <Link
                    href={
                      process.env.NEXT_PUBLIC_REACT_APP_PRODUCTION_PATH || '/'
                    }
                    aria-label="Logo-kiotfinance"
                  >
                    <h2
                      id="kfin-logo"
                      className="mb-0 flex  lg:w-[138px] lg:h-[48px] w-[104px] h-[36px] relative"
                    >
                      <Logo />
                    </h2>
                  </Link>
                </div>

                <div className="offcanvas-body lg:h-fit font-['Inter'] duration-300  lg:pb-0 pb-[10px] lg:static fixed lg:rounded-none rounded-xl max-md:shadow-navbar-shadow bg-white lg:bg-[transparent]	 lg:min-h-fit top-[-999px] right-0 lg:w-auto  flex items-center md:w-[372px]">
                  <ul className="flex lg:gap-2 h-full lg:flex-row flex-col lg:items-center navbar-nav justify-content-end flex-grow-1 m-0 p-0 lg:w-full md:w-[372px] w-[310px] rounded-[12px]">
                    <li className="mt-[22px] mr-[14px] mb-[16px] ml-6 h-8 flex justify-end lg:hidden">
                      <button
                        className="navbar-close-button hidden"
                        type="button"
                        aria-label="Close"
                        onClick={onToggleMenu}
                      >
                        <XBarIcon />
                      </button>
                    </li>
                    <HeaderLabel label="Lợi ích" navigateTo="loi-ich" />
                    <HeaderLabel
                      label="Quy trình vay"
                      navigateTo="quy-trinh-vay"
                    />
                    <HeaderLabel label="Đối tác" navigateTo="doi-tac" />
                    <HeaderLabel
                      label="Câu hỏi thường gặp"
                      navigateTo="cau-hoi-thuong-gap"
                    />

                    <div className="flex max-lg:w-full ml-3">
                      <Link
                        onClick={onClickNavbarRegisterButton}
                        id="navbar-register-button"
                        className="
                        lg:px-4 lg:py-2 flex max-lg:justify-center p-[18px] py-0 lg:my-0 my-[18px] lg:leading-5 leading-[26px]
                          lg:bg-brand-primary-500 hover:lg:bg-brand-primary-600 active:lg:bg-brand-primary-700 bg-white lg:rounded-[99px] lg:justify-center items-center lg:gap-2 lg:inline-flex cursor-pointer
                          lg:items-center font-semibold lg:text-sm text-lg
                          lg:text-white text-text-strong text-center text-decoration-none
                          hover:lg:border-l-0 hover:lg:text-white hover:text-brand-primary-500
                        "
                        target="_blank"
                        href={loanApplyUrl || '#'}
                      >
                        Đăng ký vay
                      </Link>
                    </div>
                  </ul>
                </div>
                <button
                  className="lg:hidden block open-close-button"
                  aria-label="Open"
                  type="button"
                  onClick={onToggleMenu}
                >
                  <span className="navbar-toggler-icon">
                    <MenuBarIcon />
                  </span>
                </button>
              </div>
            </nav>
          </div>
        </div>
        <div className="w-full flex ">
          <div
            className="
          flex justify-between h-full max-md:w-full  md:flex-row flex-col max-md:px-4
          3xl:mr-[67px] 2xl:mr-[45px] xl:mr-[70px] lg:mr-[69px] md:mr-10 
          2xl:ml-[120px] xl:ml-[83px] lg:ml-12 md:ml-8 
          3xl:w-[1920px] 2xl:w-[1435px] xl:w-[1176px] lg:w-[1168px] md:w-[696px] w-[343px]
        "
          >
            <div
              className=" max-md:mx-auto
        3xl:mb-[241px] 2xl:mb-[178px] xl:mb-[110px] lg:mb-[122px] md:mb-[60px] mb-0
        3xl:mt-[248px] 2xl:mt-[258px] xl:mt-[178px] lg:mt-[121px] md:mt-[100px] mt-[82px] 
         text-navy 
        3xl:max-w-[683px] 2xl:max-w-[569px] lg:max-w-[486px] md:max-w-[273px] max-w-[375px] 
        w-full flex flex-col 3xl:gap-14 2xl:gap-[46px] lg:gap-10 md:gap-[22px] gap-0  
      "
            >
              <div className="max-md:mb-6 max-md:h-[76px] flex items-center">
                <h1
                  id="header-title"
                  className="
                    3xl:text-[76px] lg:text-[54px]  text-[30px]  lg:font-extrabold font-bold 3xl:leading-[92px] lg:leading-[68px] leading-9
                    3xl:w-[683px] 2xl:w-[569px] lg:w-[486px] md:w-[273px] w-[311px]
                  "
                >
                  Giải pháp vay vốn kinh doanh
                </h1>
              </div>
              <div className="flex justify-between 3xl:w-[569px] max-md:mb-8 2xl:h-[66px] lg:h-[60px] md:h-[34px] h-[57px]">
                <div className="flex 3xl:gap-1 lg:gap-1 md:gap-[2.25px] gap-1 flex-col">
                  <div className="text-brand-navy 2xl:text-lg lg:text-sm md:text-[8px] text-xs font-normal w-fit">
                    Hạn mức lên tới
                  </div>
                  <div className="2xl:text-[30px] lg:text-2xl md:text-sm text-[20px] lg:leading-9 md:leading-5 leading-7 font-bold text-brand-primary-500">
                    1 tỷ đồng
                  </div>
                </div>
                <div className="w-[3px] h-full bg-brand-primary-100"></div>
                <div className="flex 3xl:gap-1 lg:gap-1 md:gap-[2.25px] gap-1 flex-col">
                  <div className="text-brand-navy 2xl:text-lg lg:text-sm md:text-[8px] text-xs font-normal w-fit">
                    Lãi suất từ
                  </div>
                  <div className="2xl:text-[30px] lg:text-2xl md:text-sm text-[20px] lg:leading-9 md:leading-5 leading-7  font-bold text-brand-primary-500">
                    1.3%/tháng
                  </div>
                </div>
                <div className="w-[3px] h-full bg-brand-primary-100"></div>
                <div className="flex 3xl:gap-1 lg:gap-1 md:gap-[2.25px] gap-1 flex-col">
                  <div className="text-brand-navy 2xl:text-lg lg:text-sm md:text-[8px] text-xs font-normal w-fit">
                    Thời hạn tối đa
                  </div>
                  <div className="2xl:text-[30px] lg:text-2xl md:text-sm text-[20px] lg:leading-9 md:leading-5 leading-7 font-bold text-brand-primary-500">
                    60 tháng
                  </div>
                </div>{' '}
              </div>
              {/* 3xl:h-[84px] 2xl:h-[70px] lg:h-[61px] md:h-9 h-12 */}
              <Link
                id="header-register-button"
                onClick={onClickHeroBannerRegisterButton}
                className="
                3xl:py-6 lg:px-8 lg:py-[17px] md:px-4 md:py-2 px-6 py-3 
                shadow-register-button w-fit  bg-brand-primary-500 hover:bg-brand-primary-600 active:bg-brand-primary-700 rounded-[99px] justify-center items-center gap-2 inline-flex
                3xl:text-[30px] 2xl:text-2xl 2xl:font-bold lg:text-[18px] md:text-sm text-base font-semibold
              text-white 2xl:leading-9 lg:leading-[27px] md:leading-5 leading-6 text-center text-decoration-none cursor-pointer
              "
                target="_blank"
                href={loanApplyUrl || '#'}
              >
                Đăng ký vay
              </Link>
            </div>
            <div className="relative max-md:flex max-md:justify-center max-md:overflow-hidden md:w-fit w-full">
              {/* <div className="relative 3xl:pt-[100px] 2xl:pt-[85px] xl:pt-[65px] lg:pt-[62px] md:pt-[37px]"> */}
              <div
                id="hero-background-girl"
                className="
                  max-md:ml-[-31px] 
                  relative lg:h-full md:h-[351px] h-[351px] bg-hero-background-girl bg-cover
                  3xl:w-[1032px] 2xl:w-[883px]  xl:w-[690px] lg:w-[640px] md:w-[388px] w-[374px]
                "
              >
                {SOLUTION_LIST.map((item, index) => {
                  let positionCss
                  let size
                  if (index === 0) {
                    positionCss = `3xl:mt-[260px] 3xl:ml-[104px] 2xl:mt-[217px] 2xl:ml-[98px] xl:mt-[185px] xl:ml-[52px] lg:mt-[173px] lg:ml-[45px] mt-[104px] ml-[29px]`
                    size = `3xl:w-[140px] 2xl:w-[117px] xl:w-[100px] lg:w-[94px] min-[1199px]:w-[75px] min-[991px]:w-[64px] w-fit`
                  }
                  if (index === 1) {
                    positionCss = `3xl:mt-[340px] 3xl:ml-[670px] 2xl:mt-[280px] 2xl:ml-[572px] xl:mt-[235px] xl:ml-[465px] lg:mt-[200px] lg:ml-[425px] md:mt-[120px] md:ml-[257px] mt-[110px] ml-[249px]`
                    size = `3xl:w-[113px] 2xl:w-[95px] xl:w-[81px] lg:w-[76px] min-[1199px]:w-[60px] min-[991px]:w-[64px] w-[46px] `
                  }
                  if (index === 2) {
                    positionCss = `3xl:mt-[639px] 3xl:ml-[244px] 2xl:mt-[533px] 2xl:ml-[215px] xl:mt-[455px] xl:ml-[152px] lg:mt-[426px] lg:ml-[139px] md:mt-[256px] md:ml-[86px] mt-[247px] ml-[78px]`
                    size = `3xl:w-[142px] 2xl:w-[119px] xl:w-[101px] lg:w-[95px] min-[1199px]:w-[65px] w-[63px]`
                  }
                  return (
                    <div
                      key={item.title}
                      className={`top-0  absolute flex items-center md:rounded-[28px] rounded-[12px] bg-white/80  shadow-[0px 8px 24px 0px rgba(0, 48, 104, 0.04)] w-fit 
                    3xl:py-[22.5px] 3xl:px-[34px] 3xl:gap-[22.5px] 2xl:py-[19px] 2xl:px-7 2xl:gap-[19px] xl:py-4 xl:px-6 xl:gap-4 lg:py-[15px] lg:px-[22.5px] lg:gap-[15px] py-[9px] px-[13.5px] gap-[9px]
                    3xl:h-[124px] 2xl:h-[103px] xl:h-[88px] lg:h-[82px] md:h-[50px] h-[50px] ${positionCss}`}
                    >
                      <div className="3xl:w-[80px] 2xl:w-[66px] xl:w-14 lg:w-[52.5px] w-[32px]">
                        {item.icon}
                      </div>
                      <div
                        className={`3xl:text-[22px] 2xl:text-[18px]  xl:text-base min-[1199px]:text-xs lg:text-[15px] text-[9px]  3xl:leading-[34px] 2xl:leading-[28px] xl:leading-6 lg:leading-[22.5px] leading-[13px]  max-[991px]:leading-[14px] font-semibold text-brand-navy  ${size}`}
                      >
                        {item.title}
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const HeaderLabel = ({ label, navigateTo }) => {
  const [activeSection, setActiveSection] = useState('')

  useEffect(() => {
    const handleScroll = () => {
      const section = document.getElementById(navigateTo)
      if (section) {
        const headerHeight = document.getElementById('navbar')?.offsetHeight || 0
        const rect = section.getBoundingClientRect()
        if (rect.top <= headerHeight + 50 && rect.bottom >= headerHeight) {
          setActiveSection(navigateTo)
        } else if (activeSection === navigateTo) {
          setActiveSection('')
        }
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [navigateTo, activeSection])

  function onRemoveMenu() {
    const navLinks = document.querySelector('.offcanvas-body')
    const closeButton = document.querySelector('.navbar-close-button')
    closeButton.classList.toggle('hidden')
    navLinks.classList.toggle('!top-0')
  }

  const handleClick = (e) => {
    e.preventDefault()
    onRemoveMenu()
    
    const element = document.getElementById(navigateTo)
    if (element) {
      const headerHeight = document.getElementById('navbar')?.offsetHeight || 0
      const offset = headerHeight + 20 // Thêm 20px spacing
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset
      window.scrollTo({
        top: elementPosition - offset,
        behavior: 'smooth'
      })
    }
  }

  return (
    <li className="lg:py-0 lg:mx-0 py-[4px] mx-2">
      <a
        id={`${navigateTo}-link`}
        href={`#${navigateTo}`}
        className={`
          font-semibold text-sm font-['Inter'] leading-5 text-text-strong text-decoration-none
          px-3 py-2 flex items-center rounded-[99px]
          hover:bg-white hover:text-brand-primary-500 hover:shadow-shadow-blurs
          active:bg-brand-primary-50 active:text-brand-primary-500
          ${
            activeSection === navigateTo
              ? 'bg-[#e6f1fe] !text-brand-primary-500'
              : ''
          }
        `}
        onClick={handleClick}
      >
        {label}
      </a>
    </li>
  )
}

const SOLUTION_LIST = [
  { icon: <BagIcon />, title: 'Lãi suất thấp' },
  { icon: <HeroRecycleIcon />, title: 'Tiện lợi' },
  { icon: <HeroClockIcon />, title: 'Thủ tục nhanh chóng' },
]
